import React from 'react'
import styled from '@emotion/styled'

const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 6rem auto 0;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin: 2rem auto 0;
  }
  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    margin: 4rem auto 0;
  }
  &::after {
    content: '';
    flex: 0 0 32%;
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      max-width: 208px;
    }
    @media screen and (min-width: ${props => props.theme.responsive.large}) {
      max-width: 260px;
    }
  }
`

const CardList = props => {
  return <List>{props.children}</List>
}

export default CardList
